<p-dialog
  header="Versendete E-Mails"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [blockScroll]="true"
  [style]="{ width: '600px' }"
  [closable]="true"
>
  <p-table [value]="emails" [tableStyle]="{ 'min-width': '35rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th>E-Mail</th>
        <th>Betreff</th>
        <th>Datum</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-email>
      <tr>
        <td>{{ email.recipientEmail }}</td>
        <td>{{ email.subject }}</td>
        <td>{{ email.sentAt | date: 'dd.MM.yyyy HH:mm' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center text-gray-400">Keine E-Mails vorhanden</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

